import styled, { css } from 'styled-components';

/**
 * PageContainer — the page-width primitive for embedded flows.
 *
 * An exact mirror of `lum-web`'s `.lum-web-container`: caps content at the
 * native page width (1140px), centres it, and applies the same responsive
 * horizontal gutter — 16px, 24px from the `S` breakpoint (576px), and 0 at
 * `XXL` (1440px) where the centred margins already separate content from the
 * viewport edges. Owning the gutter here (instead of in each flow) keeps every
 * flow aligned with native screens at every width.
 *
 * Vertical spacing stays the flow's responsibility: add only vertical padding
 * inside.
 *
 * `$bleed`: opt out of the gutter (width/centring only) for flows that need to
 * reach the viewport edges — e.g. card-dashboard's mobile carousel, whose card
 * widths are calibrated to `100svw`. Those flows own their own padding.
 */
const gutter = css`
  padding: 0 16px;

  @media (min-width: 576px) {
    padding: 0 24px;
  }

  @media (min-width: 1440px) {
    padding: 0;
  }
`;

export const PageContainer = styled.div<{ $bleed?: boolean }>`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  ${({ $bleed }) => ($bleed ? '' : gutter)}
`;
